import { Component, ViewChild } from '@angular/core';
import { CtvetserviceService } from '../ctvetatendance/ctvetservice.service';
import { Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-ctvetfacials',
  templateUrl: './ctvetfacials.component.html',
  styleUrls: ['./ctvetfacials.component.css']
})
export class CtvetfacialsComponent {
  searchText: string = '';

  public attendanceList: any[] = []; 
  public loading = false;

  pageSize: number = 10; 
  currentPage: number = 0; 
  totalRecords: number = 0; 
  @ViewChild(MatPaginator) paginator: MatPaginator;


  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

  constructor(private ctvetService: CtvetserviceService,
     private router: Router,
     private breakpointObserver: BreakpointObserver){}


     ngOnInit(): void {
      this.fetchAttendanceList();
    }
    fetchAttendanceList(): void {
      this.loading = true;
      this.ctvetService.viewAllAttendance() 
        .subscribe({
          next: (response) => {
            this.attendanceList = response; 
            this.totalRecords = this.attendanceList.length; 
            this.loading = false;
          },
          error: (error) => {
            console.error('Error fetching attendance data', error);
            this.loading = false;
          }
        });
    }
  
    getImageUrl(imageName: string): string {
      // Replace the base URL with your actual backend URL
      return `http://localhost:8181/ctvet/images/${imageName}`;
    }

    filterAttendanceList(): any[] {
      return this.attendanceList.filter(attendance =>
        attendance.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
        attendance.vmsId.toLowerCase().includes(this.searchText.toLowerCase()) ||
        attendance.date.toLowerCase().includes(this.searchText.toLowerCase()) ||
        attendance.course.toLowerCase().includes(this.searchText.toLowerCase()) ||
        attendance.group.toLowerCase().includes(this.searchText.toLowerCase()) ||
        attendance.status.toLowerCase().includes(this.searchText.toLowerCase())
      ).slice(this.currentPage * this.pageSize, (this.currentPage + 1) * this.pageSize); 
    }
  
    pageChanged(event: any): void {
      this.currentPage = event.pageIndex; 
      this.pageSize = event.pageSize; 
    }

}
